import Link from "next/link";
import Newsletter from "../../components/Footer/components/Newsletter/Newsletter";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import Hero from "../../components/Hero/Hero";

export default function UklonjeneKompanije() {
    return (
        <div>
            <Header />
            <Hero
                title="Uklonjene kompanije"
                subtitle="Kompanije koje su uklonjene sa portala na njihov zahtjev"
            />
            <article className="mt-16 mb-32 max-w-screen-lg mx-auto px-6 lg:px-0 prose prose-md space-y-4 leading-8">
                <p>
                    Na ovoj stranici nalaze se kompanije koje su zahtjevale da
                    budu uklonjene sa dzobs.com portala. Dzobs.com portal ne
                    ulazi u razloge ovih odluka. Uklonjene kompanije nemaju
                    mogućnost ostavljanja poslova. Uklonjene kompanije mogu
                    zahtjevati da budu vraćene, a vraćanjem kompanije vraćaju se
                    i sve prethodno ostavljene recenzije.
                </p>
                <h2 className="text-2xl mb-4">Lista uklonjenih kompanija:</h2>
                <h3>Develabs</h3>
                <h3>Asioso</h3>
            </article>
            <Newsletter bg="bg-gray-light" />
            <Footer />
        </div>
    );
}
